import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateDenominationReport = ({
  reportId,
  reportData,
  denominationId
}) => {
  return axios.put(
    `/denominations/${denominationId}/report/${reportId}`,
    reportData
  );
};

export const useUpdateDenominationReport = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["denomination-report"]);
      queryClient.invalidateQueries(["denomination-reports"]);

      setNotification({
        type: "success",
        message: "Denomination report updated successfully!"
      });
    },
    ...config,
    mutationFn: updateDenominationReport
  });
};
